/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestDeleteRemarksTemplateRequest
 */
export interface RequestDeleteRemarksTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteRemarksTemplateRequest
     */
    baseId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof RequestDeleteRemarksTemplateRequest
     */
    ids: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteRemarksTemplateRequest
     */
    tenantId: number;
    /**
     * 
     * @type {number}
     * @memberof RequestDeleteRemarksTemplateRequest
     */
    userId: number;
}

/**
 * Check if a given object implements the RequestDeleteRemarksTemplateRequest interface.
 */
export function instanceOfRequestDeleteRemarksTemplateRequest(value: object): value is RequestDeleteRemarksTemplateRequest {
    if (!('baseId' in value) || value['baseId'] === undefined) return false;
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function RequestDeleteRemarksTemplateRequestFromJSON(json: any): RequestDeleteRemarksTemplateRequest {
    return RequestDeleteRemarksTemplateRequestFromJSONTyped(json, false);
}

export function RequestDeleteRemarksTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestDeleteRemarksTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'],
        'ids': json['ids'],
        'tenantId': json['tenant_id'],
        'userId': json['user_id'],
    };
}

export function RequestDeleteRemarksTemplateRequestToJSON(json: any): RequestDeleteRemarksTemplateRequest {
    return RequestDeleteRemarksTemplateRequestToJSONTyped(json, false);
}

export function RequestDeleteRemarksTemplateRequestToJSONTyped(value?: RequestDeleteRemarksTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'ids': value['ids'],
        'tenant_id': value['tenantId'],
        'user_id': value['userId'],
    };
}

